import 'trusted-security-policies';
import MyRoutes from "./routers";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from './redux/userSlice'; // Assurez-vous que setUser est bien défini dans votre slice
import { getUser } from 'app/login/AuthService'; // Importation des fonctions d'AuthService
import Cookies from 'js-cookie'; // Pour gérer les cookies
import "styles/styles.css";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Vérifie si le token est présent dans les cookies
    const token = Cookies.get('token');
    if (token) {
      // Si le token est présent, tu peux appeler une fonction pour récupérer l'utilisateur
      // Par exemple, `getUser()` avec l'ID de l'utilisateur, si nécessaire
      const userId = Cookies.get('userId'); // Récupère l'ID de l'utilisateur depuis le cookie si tu l'as stocké
      if (userId) {
        getUser(userId)
          .then((userData:any) => {
            dispatch(setUser(userData)); // Met à jour le state avec les données de l'utilisateur
          })
          .catch((err:any) => {
            console.error("Erreur lors de la récupération de l'utilisateur :", err);
          });
      }
    }
  }, [dispatch]);

  return (
    <>
      <div className="fullScreen bgColor text-base text-neutral-900 dark:text-neutral-200 font-body">
        <MyRoutes />
      </div>
    </>
  );
}

export default App;
